import { c as _c } from "react/compiler-runtime";
import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/dialog-constants";
import { getUnheldSeatOption, isSeatLocked } from "@components/table/members/assign-seats/assign-seats-utils";
import { SeatCheckbox } from "@components/table/members/assign-seats/seat-checkbox";
import { Box } from "@mui-wrapper";
/**
 * The Sphere XG seat that the selected members without one are given along with the invite, shown
 * as the same seat card that the seats of a member are managed with, and as in the workspace invite.
 *
 * The role needs the seat, so the box is checked and cannot be unchecked, and tells how many of the
 * free seats the members take, in red when they are too few. Once none is left, the box is locked
 * and unchecked and says so in red.
 */
export function XgSeatCheckbox(t0) {
  const $ = _c(18);
  const {
    numberOfMembers,
    seatsAvailable,
    description
  } = t0;
  let T0;
  let T1;
  let t1;
  let t2;
  let t3;
  if ($[0] !== seatsAvailable) {
    const option = getUnheldSeatOption("xgSeat", undefined, seatsAvailable ?? Number.POSITIVE_INFINITY);
    T1 = Box;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        mt: SPACE_ELEMENTS_OF_MODAL
      };
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    T0 = SeatCheckbox;
    t2 = option;
    t1 = isSeatLocked(option);
    $[0] = seatsAvailable;
    $[1] = T0;
    $[2] = T1;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    T0 = $[1];
    T1 = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const t4 = !t1;
  let t5;
  if ($[7] !== T0 || $[8] !== description || $[9] !== numberOfMembers || $[10] !== seatsAvailable || $[11] !== t2 || $[12] !== t4) {
    t5 = <T0 option={t2} isChecked={t4} seatsAvailable={seatsAvailable} seatsUsed={numberOfMembers} isDisabled={true} description={description} onChange={_temp} />;
    $[7] = T0;
    $[8] = description;
    $[9] = numberOfMembers;
    $[10] = seatsAvailable;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== T1 || $[15] !== t3 || $[16] !== t5) {
    t6 = <T1 sx={t3}>{t5}</T1>;
    $[14] = T1;
    $[15] = t3;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}
function _temp() {}